import { Url } from '../../../shared/constant/url.constant';

/**
 * Route utilisées pour les service items.
 */
export namespace ConstantServiceItems {
  export const data = {
    title: 'Service Items',
    sub: {
      lister: 'Lister',
      ajouter: 'Ajouter',
      ajout: {
        title: 'Ajout d\'un service items'
      },
      liste: 'Liste',
      list: {
        title: 'Liste des services items'
      }
    }

  }
  export const url = {
    SERVICE_ITEMS: {
      SERVICE_ITEMS_: 'service_items',
      LIST: 'liste',
      ADD: 'add'
    }
  };

  export const urlFull = {
    SERVICE_ITEMS: {
      ADD: ConstantServiceItems.url.SERVICE_ITEMS.SERVICE_ITEMS_
        .concat(Url.SLASH_ROUTE).concat(ConstantServiceItems.url.SERVICE_ITEMS.ADD),
      LIST: ConstantServiceItems.url.SERVICE_ITEMS.SERVICE_ITEMS_
        .concat(Url.SLASH_ROUTE).concat(ConstantServiceItems.url.SERVICE_ITEMS.LIST),
    }
  };
}
